import { TFunction } from 'i18next'
import { DocumentErrorDetails } from '../error-handler.backend-types'

export function getNegativeVatMessage(t: TFunction, details?: DocumentErrorDetails<'NEGATIVE_VAT'>): string | null {
  return t('pms.common.checkout_document.save.error_negative_vat')
}
